import { ReportVersionSelector } from 'src/components/star-grid/components/ReportVersionSelector';
import Icon from '@amzn/awsui-components-core/icon';
import Button from '@amzn/awsui-components-core/button';
import Multiselect, { MultiselectProps } from '@amzn/awsui-components-core/multiselect';
import Select from '@amzn/awsui-components-core/select';
import React from 'react';
import { ReportFilterBarProps, useReportFilterBar } from 'src/components/star-grid/hooks/useReportFilterBar';
import { ReportFilterField } from 'src/components/star-grid/utils/reportFilters';
import styles from './styles/ReportFilterBar.module.scss';

type FilterBarState = ReturnType<typeof useReportFilterBar>;
interface DimensionFilterProps {
  readonly field: ReportFilterField & { readonly control: MultiselectProps };
}

const DimensionFilter: React.FC<DimensionFilterProps> = ({ field }) => (
  <div className={styles.field}>
    <label className={styles.label} htmlFor={field.control.controlId}>
      {field.label}
    </label>
    <div className={styles.control}>
      <Multiselect {...field.control} data-testid={`report-filter-${field.key}`} />
      <span className={styles.chevron} aria-hidden="true">
        <Icon name="angle-down" size="small" />
      </span>
    </div>
  </div>
);

const ScaleFilter: React.FC<{ readonly state: FilterBarState }> = ({ state }) => (
  <div className={styles.scale}>
    <label className={styles.label} htmlFor="stargrid-report-scale">
      {state.text('reportScale')}
    </label>
    <div className={styles.control}>
      <Select
        controlId="stargrid-report-scale"
        ariaLabel={state.text('reportScale')}
        selectedOption={state.selectedScale}
        options={state.scaleOptions}
        onChange={state.changeScale}
        expandToViewport
        data-testid="stargrid-report-scale-select"
      />
      <span className={styles.chevron} aria-hidden="true">
        <Icon name="angle-down" size="small" />
      </span>
    </div>
  </div>
);

export const ReportFilterBar: React.FC<ReportFilterBarProps> = (props) => {
  const state = useReportFilterBar(props);
  return (
    <section id="stargrid-report-filters" className={styles.toolbar} aria-label={state.text('reportFilters')}>
      <div className={styles.fields}>
        {props.selectors && (
          <ReportVersionSelector
            label={state.text('reportVersion')}
            controlId="stargrid-report-version"
            control={props.selectors.version}
            choices={props.selectors.versionChoices}
          />
        )}
        {state.fields.map((field) => (
          <DimensionFilter key={field.key} field={field} />
        ))}
        <ScaleFilter state={state} />
      </div>
      <Button variant="inline-link" iconName="undo" onClick={props.onReset} disabled={props.disabled} data-testid="report-reset-filters">
        {state.text('resetReportView')}
      </Button>
    </section>
  );
};
